import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import ExecutiveSummary from './ExecutiveSummary';
import CompanyOverview from './CompanyOverview';
import MarketOpportunity from './MarketOpportunity';
import InclusionSummary from './InclusionSummary';
import PublicOffering from './PublicOffering';
import TechScalability from './TechScalability';
import CompetitiveAdvantage from './CompetitiveAdvantage';
import MarketGrowthStrategy from './MarketGrowthStrategy';
import FinancialProjections from './FinancialProjections';
import Investment from './Investment';
import RiskandMitigation from './RiskandMitigation';
import ExitStrategy from './ExitStrategy';
import Conclusion from './Conclusion';

const Home = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.navbarContainer}>
        <Navbar />
      </div>
      <div style={styles.contentContainer}>
        <Sidebar />
        <div style={styles.mainContent}>
          <Routes>
            <Route path="/" element={<Navigate to="executive-summary" replace />} /> {/* Default Route */}
            <Route path="executive-summary" element={<ExecutiveSummary />} />
            <Route path="companyoverview" element={<CompanyOverview />} />
            <Route path="marketopportunity" element={<MarketOpportunity />} />
            <Route path="inclusionsummary" element={<InclusionSummary />} />
            <Route path="pooffering" element={<PublicOffering />} />
            <Route path="techscalability" element={<TechScalability />} />
            <Route path="competitiveadvantage" element={<CompetitiveAdvantage />} />
            <Route path="marketgrowthstrategy" element={<MarketGrowthStrategy />} />
            <Route path="financialprojections" element={<FinancialProjections />} />
            <Route path="investment" element={<Investment />} />
            <Route path="riskandmitigation" element={<RiskandMitigation />} />
            <Route path="exitstrategy" element={<ExitStrategy />} />
            <Route path="conclusion" element={<Conclusion />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    minWidth: '100vw',
    backgroundColor: '#f9f9f9',
    boxSizing: 'border-box',
  },
  navbarContainer: {
    width: '100%',
    backgroundColor: '#333',
    height: '60px',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    backgroundColor: '#f9f9f9',
    minHeight: 'calc(100vh - 60px)',
  },
  mainContent: {
    marginLeft: '300px',
    padding: '20px',
    flexGrow: 1,
    backgroundColor: '#f9f9f9',
  },
};

export default Home;
